import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchDataSourcesFromApi } from "../../api/DataSourcesApi";

type DataSourcesState = {
    loaded: boolean;
    sources: any[];
    error: string;
    appliedDataSources: any[]
}

const initialState: DataSourcesState = {
    loaded: false,
    sources: [],
    error: '',
    appliedDataSources: []
};

const dataSourcesSlice = createSlice({
    name: "dataSources",
    initialState: initialState,
    reducers: {
        applyDataSources: (state, action: PayloadAction<any>) => {
            state.appliedDataSources = [...action.payload];
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getDataSources.pending, state => {
                state.loaded = false;
            })
            .addCase(getDataSources.fulfilled, (state, action: any) => {
                state.loaded = true;
                state.sources = action.payload;
            })
            .addCase(getDataSources.rejected, state => {
                state.error = "Unable to fetch data sources";
                state.loaded = false;
            })
    }
})

export const getDataSources = createAsyncThunk(
    "dataSources/getDataSources",
    async () => {
        return await fetchDataSourcesFromApi();
    }
)

export default dataSourcesSlice.reducer;
export const { applyDataSources } = dataSourcesSlice.actions;

export const selectDataSources = (state: any) => state.dataSources.sources;
export const selectAppliedDataSources = (state: any) => state.dataSources.appliedDataSources;
export const selectAppliedDataSourcesAsRequest = (state: any) => {
    const mapSelected: any = {};
    if (state.dataSources.appliedDataSources.length === 0) {
        state.dataSources.sources.forEach((source: any) => {
            mapSelected[source.table] = true;
        });
    } else {
        state.dataSources.sources.forEach((source: any) => {
            mapSelected[source.table] = state.dataSources.appliedDataSources.some((s: any) => s.table === source.table);
        });
    }
    return mapSelected;
}
export const selectDataSourcesLoaded = (state: any) => state.dataSources.loaded;
export const selectDataSourcesError = (state: any) => state.dataSources.error;